"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickinessChartSettingsComponent = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const StickinessHighchartsSettingsChartTypeComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/state/data/highchartsSettings/StickinessHighchartsSettingsChartTypeComponent");
const lodash_1 = __importDefault(require("lodash"));
const StickinessPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessPageDataProvider");
const StickinessChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/model/StickinessChartSettingsJSONModel");
const StickinessHighchartsSettingsStickinessTableComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/state/data/StickinessHighchartsSettingsStickinessTableComponent");
const StickinessHighchartsSettingsFilterCohortDaysComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/state/data/highchartsSettings/StickinessHighchartsSettingsFilterCohortDaysComponent");
const StickinessHighchartsSettingsFilterFrequencyComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/state/data/highchartsSettings/StickinessHighchartsSettingsFilterFrequencyComponent");
const StickinessChartSettingsComponent = () => {
    const stickinessPageDataContext = (0, StickinessPageDataProvider_1.useStickinessPageDataContext)();
    const { inProgress, loaded } = stickinessPageDataContext.state.status;
    const { isError } = stickinessPageDataContext.state.error;
    const jsonModel = stickinessPageDataContext.stateFns.getURLJSONModel();
    const chartType = jsonModel.getChartSettingsJSONModel().getChartType();
    const lineType = jsonModel.getLineTypeJSONModel().getLineType();
    const isOvertime = chartType === StickinessChartSettingsJSONModel_1.ChartType.overtime;
    const disabled = inProgress || isError || !loaded || lodash_1.default.isNil(stickinessPageDataContext.state.data);
    return React.createElement(antd_1.Row, { justify: "end", align: "middle", className: "highchartsSettingsRow" },
        React.createElement(antd_1.Col, null,
            React.createElement(antd_1.Space, { className: "highchartsOptionsComponent" },
                React.createElement(StickinessHighchartsSettingsChartTypeComponent_1.StickinessHighchartsSettingsChartTypeComponent, null),
                !isOvertime && React.createElement(StickinessHighchartsSettingsFilterCohortDaysComponent_1.StickinessHighchartsSettingsFilterCohortDaysComponent, null),
                isOvertime && React.createElement(StickinessHighchartsSettingsFilterFrequencyComponent_1.StickinessHighchartsSettingsFilterFrequencyComponent, null),
                React.createElement(StickinessHighchartsSettingsStickinessTableComponent_1.StickinessHighchartsSettingsStickinessTableComponent, { disabled: disabled, lineType: lineType }))));
};
exports.StickinessChartSettingsComponent = StickinessChartSettingsComponent;
